export default "__VITE_ASSET__CijjXxJh__"